import * as React from 'react';
import './index.css';

export default function UserPos({ rows, handleChangePosId, modalPosIds, handleSelectAllPosIds }) {
  const selectedPosCount = Object.keys(modalPosIds).length;
  const allRowsCount = rows.length;
  var checkbox = document.getElementById("selectAllStores");
  if (checkbox)
  {
    if (selectedPosCount )
      checkbox.indeterminate = true;
    else
      checkbox.indeterminate = false;
  }
  
  return (
    <>
      <div className='container userPosTable'>
        <div className='flex-row'>
          <div className='grid grid-cols-12 gap-2 headers'>
            <div><input id="selectAllStores" type="checkbox" onChange={handleSelectAllPosIds} checked={selectedPosCount == allRowsCount} /></div>
            <div className='col-span-3'>Store name</div>
            <div className='col-span-2'>Code</div>
            <div className='col-span-2'>Region</div>
            <div className='col-span-2'>Nation</div>
            <div className='col-span-2'>Type</div>
          </div>
        </div>
          {rows.map(( {posId, posDs, virtualStoreId, country, posTypeId } ) => {
            const activeClass = modalPosIds[posId] == true ? 'checked' : '';
            return (
              <div className={`flex-row mt-2`}>
                <div className={`grid grid-cols-12 gap-2 row ${activeClass}`}>
                  <div><input type="checkbox" value={posId} onChange={handleChangePosId} checked={activeClass} /></div>
                  <div className='col-span-3'>{posDs}</div>
                  <div className='col-span-2'>{posId}</div>
                  <div className='col-span-2'>{virtualStoreId}</div>
                  <div className='col-span-2'>{country?.countryDs}</div>
                  <div className='col-span-2'>{posTypeId}</div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}